import {
  FETCH_RESERVERINGSSYSTEMEN_REQUEST,
  FETCH_RESERVERINGSSYSTEMEN_SUCCESS,
  FETCH_RESERVERINGSSYSTEMEN_ERROR,
  FETCH_RESERVERINGSSYSTEEM_REQUEST,
  FETCH_RESERVERINGSSYSTEEM_SUCCESS,
  FETCH_RESERVERINGSSYSTEEM_ERROR,
  CREATE_RESERVERINGSSYSTEEM_REQUEST,
  CREATE_RESERVERINGSSYSTEEM_SUCCESS,
  CREATE_RESERVERINGSSYSTEEM_ERROR,
  UPDATE_RESERVERINGSSYSTEEM_REQUEST,
  UPDATE_RESERVERINGSSYSTEEM_SUCCESS,
  UPDATE_RESERVERINGSSYSTEEM_ERROR,
  DELETE_RESERVERINGSSYSTEEM_REQUEST,
  DELETE_RESERVERINGSSYSTEEM_SUCCESS,
  DELETE_RESERVERINGSSYSTEEM_ERROR
} from "./actions";

const initialState = {
  items: [],
  selectedItem: null,
  loading: false,
  error: null,
  success: null
};

export default function reserveringssystemenReducer(state = initialState, action) {
  switch (action.type) {
    // Fetch alle reserveringssystemen
    case FETCH_RESERVERINGSSYSTEMEN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case FETCH_RESERVERINGSSYSTEMEN_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload,
        error: null
      };
    
    case FETCH_RESERVERINGSSYSTEMEN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Fetch één reserveringssysteem
    case FETCH_RESERVERINGSSYSTEEM_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case FETCH_RESERVERINGSSYSTEEM_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedItem: action.payload,
        error: null
      };
    
    case FETCH_RESERVERINGSSYSTEEM_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Maak nieuw reserveringssysteem
    case CREATE_RESERVERINGSSYSTEEM_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case CREATE_RESERVERINGSSYSTEEM_SUCCESS:
      return {
        ...state,
        loading: false,
        items: [...state.items, action.payload],
        error: null,
        success: "Reserveringssysteem succesvol aangemaakt"
      };
    
    case CREATE_RESERVERINGSSYSTEEM_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Update reserveringssysteem
    case UPDATE_RESERVERINGSSYSTEEM_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case UPDATE_RESERVERINGSSYSTEEM_SUCCESS:
      return {
        ...state,
        loading: false,
        items: state.items.map(item => 
          item._id === action.payload.id ? action.payload.data : item
        ),
        selectedItem: state.selectedItem && state.selectedItem._id === action.payload.id 
          ? action.payload.data 
          : state.selectedItem,
        error: null,
        success: "Reserveringssysteem succesvol bijgewerkt"
      };
    
    case UPDATE_RESERVERINGSSYSTEEM_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Verwijder reserveringssysteem
    case DELETE_RESERVERINGSSYSTEEM_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case DELETE_RESERVERINGSSYSTEEM_SUCCESS:
      return {
        ...state,
        loading: false,
        items: state.items.filter(item => item._id !== action.payload),
        selectedItem: state.selectedItem && state.selectedItem._id === action.payload 
          ? null 
          : state.selectedItem,
        error: null,
        success: "Reserveringssysteem succesvol verwijderd"
      };
    
    case DELETE_RESERVERINGSSYSTEEM_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
}